/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const SubmissionActions = {
  ADD_FIELD_TO_CLEAR: 'ADD_FIELD_TO_CLEAR',
  REMOVE_FIELD_TO_CLEAR: 'REMOVE_FIELD_TO_CLEAR',
};

/**
 * Handles currently edited submission state.
 */
export const SubmissionReducer = (state, action) => {
  switch (action.type) {
    case SubmissionActions.ADD_FIELD_TO_CLEAR:
      return {
        ...state,
        fieldsToClear: [action.payload, ...state.fieldsToClear],
      };

    case SubmissionActions.REMOVE_FIELD_TO_CLEAR:
      return {
        ...state,
        fieldsToClear: state.fieldsToClear.filter(item => action.payload !== item),
      };

    default:
      return state;
  }
};

export const SubmissionInitialState = {
  fieldsToClear: [],
};
